<template>
    <el-dialog
        title="เพิ่มตำแหน่ง"
        v-loading="isLoading"
        :visible.sync="show"
        width="672px"
    >
        <div>
            <el-form
                ref="formRole"
                :model="formRole"
                :rules="ruleCreateRole"
                label-position="left"
                label-width="160px"
            >
                <el-form-item label="ตำแหน่ง" prop="description">
                    <el-input
                        v-model="formRole.description"
                        placeholder="กรอกตำแหน่ง"
                        autocomplete="on"
                    ></el-input>
                        <!-- :disabled="isEdit" -->
                </el-form-item>
                <el-form-item label="สถานะ" prop="status">
                    <div
                        class="switch-box"
                        :class="{ 'close-color': !formRole.status }"
                    >
                        <el-switch
                            v-model="formRole.status"
                            active-color="#26AA5D"
                        >
                        </el-switch>
                        <div>
                            {{ formRole.status ? "เปิดใช้งาน" : "ปิด" }}
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    label="สิทธิ์การใช้งาน"
                    prop="permissions"
                    class="permissions-wrapper"
                >
                <!-- <span v-html="character"></span> -->
                    <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="isCheckAll"
                        @change="checkBoxAll"
                        >เลือกทั้งหมด
                    </el-checkbox>
                    <el-tree
                        class="content"
                        :data="permissionsInfo && permissionsInfo.resource"
                        show-checkbox
                        default-expand-all
                        node-key="permissionId"
                        ref="tree"
                        highlight-current
                        :props="defaultProps"
                        @check-change="changeTree"
                    >
                    </el-tree>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false" plain>ยกเลิก</el-button>
            <el-button type="primary" @click="submitForm('formRole')"
                >บันทึก</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import roleManagementApi from '@/services/fillgoods/roleManagement.js'

export default {
    name: 'ModalRoleForm',
    props: {
        isDialog: {
            type: Boolean,
            default: true
        },
        isEdit: {
            // กดจาก create = 0 or edit = 1
            type: Boolean,
            default: false
        },
        dataEditRole: {
            type: Object,
            required: true
        },
        allKeys: {
            type: Array,
            required: true
        },
        permissionsInfo: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.user.objUser
        }),
        show: {
            get () {
                return this.isDialog
            },
            set (val) {
                this.cancelForm()
            }
        }
    },
    data () {
        let validateRolename = (rule, value, callback) => {
            if (value) {
                const stringReg = /[^\u0E00-\u0E7Fa-zA-Z0-9\s]/g.test(
                    this.formRole.description
                )
                if (stringReg) {
                    callback(
                        new Error('ไม่อนุญาตให้ใส่อักขระพิเศษ หรือ Emoji')
                    )
                }
                if (this.arrValidate.length > 0) {
                    this.arrValidate.map(item => {
                        if (item.field === 'description') {
                            callback(new Error(item.message))
                        }
                    })
                }
                callback()
            }
        }
        let validatePermission = (rule, value, callback) => {
            this.formRole.permissions = this.$refs.tree.getCheckedKeys()
            if (this.formRole.permissions.length === 0) {
                callback(
                    new Error('กรุณาเลือกสิทธิ์การใช้งานอย่างน้อย 1 รายการ')
                )
            }
            if (this.arrValidate.length > 0) {
                this.arrValidate.map(item => {
                    if (item.field === 'permissions') {
                        callback(new Error(item.message))
                    }
                })
            }
            callback()
        }

        return {
            isIndeterminate: false,
            isCheckAll: false,
            formRole: {
                description: '',
                permissions: [],
                status: true
            },
            ruleCreateRole: {
                description: [
                    {
                        required: true,
                        message: 'กรุณากรอกตำแหน่ง',
                        trigger: 'blur'
                    },
                    {
                        validator: validateRolename,
                        trigger: ['blur', 'change']
                    }
                ],
                permissions: [
                    {
                        type: 'array',
                        required: true,
                        message: 'กรุณาเลือกสิทธิ์การใช้งานอย่างน้อย 1 รายการ',
                        trigger: 'blur'
                    },
                    {
                        validator: validatePermission,
                        trigger: ['blur', 'change']
                    }
                ]
            },
            isLoading: false,
            defaultProps: {
                children: 'childs',
                label: 'description'
            },
            arrValidate: []
        }
    },
    methods: {
        changeTree () {
            this.isCheckAll =
                this.$refs.tree.getCheckedKeys().length ===
                this.permissionsInfo.total
            this.isIndeterminate =
                this.$refs.tree.getCheckedKeys().length > 0 &&
                this.$refs.tree.getCheckedKeys().length <
                    this.permissionsInfo.total
        },
        checkBoxAll (val) {
            this.$refs.tree.setCheckedKeys(this.allKeys)
            this.isIndeterminate = false
            if (!val) {
                this.$refs.tree.setCheckedKeys([])
            }
        },
        submitForm (formName) {
            let checkedBoxs = this.$refs.tree.getCheckedKeys()
            let diffCheckedBoxs = checkedBoxs.filter(
                (x) => !this.allKeys.includes(x)
            )

            this.$refs[formName].validate((valid) => {
                const { description, status, id } = this.formRole
                const data = {
                    // ...this.formRole,
                    id: id,
                    description: description,
                    status: status,
                    is_editable: true,
                    permission_ids: diffCheckedBoxs
                }
                if (valid) {
                    this.isLoading = true
                    if (this.isEdit) {
                        this.editRole(data)
                    } else {
                        this.createRole(data)
                    }
                } else {
                    return false
                }
            })
        },
        async createRole (value) {
            try {
                const { success } = await roleManagementApi.createRole(value)
                if (success) {
                    this.isLoading = false
                    this.$message.success('บันทึกข้อมูลสำเร็จแล้ว')
                    this.resetField()
                    this.$emit('isSuccess', true)
                    this.$emit('close', false)
                }
            } catch (err) {
                this.isLoading = false
                console.log('something was wrong!', err)
                if (err.status === 409 || err.status === 400) {
                    err.data.errors.forEach((el) => {
                        this.arrValidate.push({ ...el })
                        this.$refs.formRole.validateField(el.field)
                    })
                } else {
                    this.$message.error(
                        'บันทึกข้อมูลไม่สำเร็จ กรุณาทำรายการใหม่อีกครั้ง'
                    )
                }
            }
        },
        async editRole (value) {
            try {
                const { success } = await roleManagementApi.editRole(value)
                if (success) {
                    this.isLoading = false
                    this.$message.success('บันทึกข้อมูลสำเร็จแล้ว')
                    this.resetField()
                    this.$emit('isSuccess', true)
                    this.$emit('close', false)
                }
            } catch (err) {
                this.isLoading = false
                console.log('something was wrong!', err)
                if (err.status === 409 || err.status === 400) {
                    err.data.errors.forEach((el) => {
                        this.arrValidate.push({ ...el })
                        this.$refs.formRole.validateField(el.field)
                    })
                } else {
                    this.$message.error(
                        'บันทึกข้อมูลไม่สำเร็จ กรุณาทำรายการใหม่อีกครั้ง'
                    )
                }
            }
        },
        cancelForm () {
            this.$swal({
                title: 'ออกจากหน้านี้',
                text: 'คุณต้องการออกจากหน้านี้โดยไม่บันทึกข้อมูลใช่หรือไม่',
                icon: 'warning',
                type: 'warning',
                showCancelButton: true,
                cancelButtonText: 'ไม่ใช่',
                confirmButtonText: 'ใช่',
                reverseButtons: true,
                iconHtml: `<img src="${require('@/assets/swal-icons/status.svg')}" />`,
                customClass: {
                    container: 'oms-swal'
                }
            }).then((val) => {
                if (val.isConfirmed) {
                    this.resetField()
                    this.$emit('close', false)
                } else {
                    return false
                }
            })
        },
        resetField () {
            this.$refs.formRole.resetFields()
            this.$refs.tree.setCheckedKeys([])
        }
    },
    watch: {
        isEdit: {
            // open modal for edit
            handler (val) {
                this.$nextTick(() => {
                    this.resetField()
                    if (val) {
                        const { permissionsIds } = this.dataEditRole
                        this.formRole = this.dataEditRole
                        this.formRole.permissions = permissionsIds
                        this.$refs.tree.setCheckedKeys(permissionsIds)
                        this.isCheckAll =
                            permissionsIds.length === this.allKeys.length
                        this.isIndeterminate =
                            permissionsIds.length > 0 &&
                            permissionsIds.length < this.allKeys.length
                    }
                })
            },
            immediate: true
        },
        formRole: {
            handler () {
                this.arrValidate = []
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
.content {
    border-radius: 4px;
    margin-top: 24px;
    // padding: 24px;
    box-sizing: border-box;
    border: 1px solid #e4e6ee;
    border-bottom: 1px solid transparent;
}
::v-deep .el-tree{
    &-node {
        &__content {
            margin-bottom: 14px;
            padding-left: 40px !important;
            .el-icon-caret-right {
                &:before {
                    content: none;
                }
            }
        }
    }
    &--highlight-current{
        .el-tree-node.is-current{
            > .el-tree-node__content{
                background-color: unset;
            }
        }
    }
}
::v-deep [role="tree"] {
    > [role="treeitem"] {
        color: $dark;
        border-bottom: 1px solid #e4e6ee;
        padding: 13px 19px;
        > .el-tree-node__content {
            padding-left: 0px !important;
        }
        > [role="group"]{
            .el-tree-node__label{
                color: $strong-gray;
            }
        }
    }
}
.line-body {
    width: 114%;
    height: 1px;
    margin-left: -24px;
    &-error {
        background-color: #ffd8da;
    }
    &-success {
        background-color: #e4e6ee;
    }
}
.switch-box {
    display: flex;
    align-items: center;
    color: $green;
    &.close-color {
        color: $gray;
    }
    .el-switch {
        margin-right: 15px;
    }
}
::v-deep .el-dialog {
    border-radius: 4px;
    &__body {
        padding: 24px 88px 0px 24px !important;
    }
    &__header {
        display: flex;
        background-color: $primary-color;
        padding: 10px 24px;
    }
    &__title {
        color: white;
        font-weight: 500;
    }
    &__headerbtn {
        font-size: 20px;
        top: unset;
        .el-dialog__close {
            color: white;
        }
    }
    &__footer {
        padding: 20px 88px 25px 24px !important;
        .el-button {
            min-width: 88px;
            &.is-plain {
                border-color: $primary-color;
                color: $primary-color;
            }
        }
    }
    .el-form-item {
        transition: all 0.3s ease;
        &.permissions-wrapper.is-error {
            .el-form-item__error {
                position: absolute;
                top: 31px;
            }
        }
        &.is-error {
            .el-form-item {
                &__content {
                    .el-checkbox__inner {
                        border-color: $message-error;
                    }
                }
            }
            .content {
                background: #fff9f9;
                border: 1px solid #ffd8da;
                border-bottom: 1px solid transparent;
                .el-checkbox {
                    &__inner {
                        border-color: $message-error;
                    }
                }
            }
            [role="tree"] {
                > [role="treeitem"] {
                    // &:last-of-type {
                    border-bottom: 1px solid #ffd8da;
                    padding: 24px;
                    // }
                }
                // &:last-child{
                //     border-bottom: 2px solid blue !important;
                // }
            }
        }
        &__error {
            position: relative;
            padding-top: 8px;
            transition: all 0.3s ease;
        }
        &__content {
            text-align: left;
            transition: height 1s ease;
        }
        &.is-required:not(.is-no-asterisk) > .el-form-item__label {
            &:before {
                content: none;
            }
            &:after {
                content: "*";
                color: #f56c6c;
                margin-left: 4px;
            }
        }
    }
    // .el-input{
    //     &.is-disabled{
    //         .el-input__inner{
    //             color: #606266;
    //         }
    //     }
    // }
}
</style>
